import { PROFILE_DESCRIPTIONS } from '../../utils/profileDescriptions';
import ViewTraitQuizDetailsButton from '../ViewTraitQuizDetailsButton/ViewTraitQuizDetailsButton';
import styles from './TraitProfileCard.module.css';

const TraitProfileCard = ({ profile, confidence, blend, id }) => {
  const description = profile ? PROFILE_DESCRIPTIONS[profile] : null;
//   const topBlends = blend
//     ? Object.entries(blend).sort((a, b) => b[1] - a[1]).slice(0, 2)
//     : [];

  const emojiMap = {
    "The Quiet Craftsman": "🛠️",
    "The Assertive Competitor": "🔥",
    "The Disciplined Driver": "📈",
    "The Resilient Maverick": "🧗",
    "The Adaptive Learner": "📚",
    "The Steady Supporter": "🫶",
    "The Coach's Mirror": "🪞"
  };

  return (
    <div className={styles.resultsArea}>
      <h2 className={styles.title}>Trait Assessment Profile</h2>
      <div className={styles.resultsList}>
        <div className={styles.resultCard}>
          {profile ? (
            <>
              <div className={styles.profileHeader}>
                <span className={styles.emoji}>{emojiMap[profile] || "💡"}</span>
                <p className={styles.profileName}>{profile}</p>
                <span className={styles.confidenceBadge}>
                  {(confidence * 100).toFixed(0)}% match
                </span>
              </div>
              <p className={styles.summary}>{description?.summary}</p>
              <div className={styles.viewButtonWrapper}>
                <ViewTraitQuizDetailsButton attemptId={id} />
              </div>
            </>
          ) : (
            <p className={styles.noResults}>No trait assessment results yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TraitProfileCard;